import ApiService from '@shared/services/api.service';

const endPoint = '/tags';

const TagsService = {
  getList(id = null) {
    let url = endPoint;
    if (id) url += `/customer/${id}`;
    return ApiService.get(url);
  },

  create(bodyParams) {
    return ApiService.post(`${endPoint}`, bodyParams);
  },

  get(id) {
    return ApiService.get(`${endPoint}/${id}`);
  },

  update(id, bodyParams) {
    return ApiService.put(`${endPoint}/${id}`, bodyParams);
  },

  delete(id) {
    return ApiService.delete(`${endPoint}/${id}`);
  },

  getUrlsByTag(id) {
    return ApiService.get(`${endPoint}/${id}/urls`);
  },

  removeUrlFromTag(tagId, urlId) {
    return ApiService.delete(`${endPoint}/${tagId}/urls/${urlId}`);
  },

  addUrlToTag(tagId, urlId) {
    return ApiService.post(`${endPoint}/${tagId}/urls/${urlId}`);
  },

  addUrlsToTagBatch(tagId, urlIds) {
    return ApiService.post(`${endPoint}/${tagId}/batch`, { urlIds: urlIds });
  }
};

export default TagsService;
